<template>
  <Layout id="FAQ-Page">
    <heroSection :header = "header"/>
    <main class="container mt-5  pt-96 pb-96 ">
      <div class="col-md-12 mx-auto">
      <template v-for="(faq,i) in faqs">
      <faq-component
      :key="i"
      :question = "faq.q"
      :answer = "faq.a"
      :iterator = "i"
      />
      </template>
      </div>
    </main>
  </Layout>
</template>

<script>
import Layout from '../layouts/main'
import heroSection from '../components/heroSectionHome'
import faqComponent from '../components/faq-component'
import faq from '../assets/data/FAQs.json'

export default {
  name: "FAQ-Page",
  components: { Layout , heroSection , faqComponent},
  data(){
    return{
    faqs : faq.data,
    header: "Frequently asked questions",
    }
  },
  beforeMount(){
    this.$store.state.currentPage = "faq";
  },
  mounted(){
    let self = this;
    var elts = document.getElementsByTagName("a");
    for (var i = elts.length - 1; i >= 0; --i) {
      elts[i].setAttribute('data-attribute',self.$options.name)
    }
  }
}
</script>

